import { render, staticRenderFns } from "./BcNotesDialog.vue?vue&type=template&id=08c17c28"
import script from "./BcNotesDialog.vue?vue&type=script&lang=js"
export * from "./BcNotesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports